import { render, staticRenderFns } from "./TriggerDetail.vue?vue&type=template&id=283c185f&"
import script from "./TriggerDetail.vue?vue&type=script&lang=js&"
export * from "./TriggerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports